<template>
    <div
         ref="div_container"
         class="col s12 no-padding"
    >
        <div ref="div_selected"
             class="col s12 no-padding border-bottom-1 grey-border"
             v-show="!is_selected"
        >
            <div
                    @click="triggerSelection"
                    class="col s11 content font-size-l"
            >
                {{selected_title}}
            </div>
            <div @click="triggerSelection"
                 v-show="!is_expanded"
                 class="col s1 no-padding center-align close padding-top-half padding-bottom-half"
            >
                <i class="material-icons">expand_more</i>
            </div>
            <div @click="clearSelection"
                 v-show="is_expanded"
                 class="col s1 no-padding center-align close padding-top-half padding-bottom-half"
            >
                <i class="material-icons">close</i>
            </div>
        </div>
        <div ref="div_select_box"
             class="col s12 no-padding"
             v-if="(is_selected == true)"
        >
            <div class="col s12 no-padding">
                <div class="col s10 input-field">
                    <input ref="input_filter"
                           type="text"
                           data-length="100"
                           v-model="filter_value"
                    />
                </div>
                <div class="col s2">
                    <a @click.prevent="cancelSelection"
                       ref="btn_cancel_selection"
                       class="answer btn-small right bold vert-offset-bottom-1 grey black-text">
                        <i class="material-icons">close</i>
                    </a>
                </div>

            </div>

            <div
                 ref="div_select_list"
                 class="col s12 no-padding"
            >
                <div v-for="opt in options"
                     :key="opt.key"
                     :value="opt.key"
                     class="col s12 no-padding">
                    <a @click.prevent="selectOption(opt)"
                       class="answer btn btn-block btn-large bold vert-offset-bottom-1 white black-text"
                       v-show="arrVisibleOptions.indexOf(opt)>=0"
                    >
                        {{ opt.name}}
                    </a>
                </div>
            </div>

            <div class="col s12 no-padding">
                <a @click.prevent="cancelSelection"
                   class="answer btn btn-block btn-large bold vert-offset-bottom-1 grey black-text" >
                    Cancel
                </a>
            </div>
        </div>
        <input
                type="hidden"
                ref="input_value"
                :value="value"

        />
    </div>
</template>

<script>
    export default {
        name: "custom-select-component",
        props: {
            title: {
                type: String
            },
            options: {
                type: Array
            },

            value: {
                type: [Number, String],
                default: ""
            },
        },
        data() {
            return {
                instance: undefined,
                is_selected : false,
                is_expanded: false,
                arrVisibleOptions: [],
                filter_value: "",
                selected_option: null,
                selected_title: "",
                selected_value : ""
            };
        },
        mounted() {
            this.selected_value = this.value;
            this.init();
            this.$el.addEventListener("change", this.changeHandler);
        },
        methods: {

            selectOption(option)
            {
                this.selected_option = option;
                this.is_expanded = true;
                this.is_selected = false;
            },
            cancelSelection()
            {
                this.is_selected = false;
                this.filter_value = "";
            },
            clearSelection()
            {
                this.selected_title = this.title;
                this.selected_value = "";
                this.is_expanded = false;
                this.filter_value = "";
            },
            expandSelection()
            {
                this.$refs.content_selector.trigger("click");
            },
            triggerSelection()
            {
                this.is_selected = true;
            },

            initTitle()
            {
                if(typeof this.title !== "undefined" && this.title !== null && this.title.length > 0)
                    this.selected_title = this.title;
                else
                    this.selected_title = "Select Option";
                this.selected_value = "";
            },
            init()
            {
                this.instance = this;
                this.arrVisibleOptions = this.options;
                this.initTitle();
                if(typeof this.value !== "undefined" && this.value !== null && this.value.length > 0)
                {
                    console.log("VALUE: " + JSON.stringify(this.value));
                    var _instance = this;
                    var _filteredList = this.arrVisibleOptions.filter(function(_item)
                    {
                        return (_item.value == _instance.value);
                    });

                    if(_filteredList.length > 0)
                    {
                        this.selected_option = _filteredList[0];
                    }
                }

            },
            changeHandler({ target }) {
                console.log("Input Change: " + target.value);
                this.$emit("input", target.value);
            }
        }
        ,
        watch:
        {
            'filter_value': function(_value)
            {
                if(typeof _value === "undefined" || _value === null || _value.length <= 0)
                {
                    this.arrVisibleOptions = this.options;
                    return false;
                }

                this.arrVisibleOptions = this.options.filter(function(_item)
                {
                    return (_item.name.toLowerCase().startsWith(_value.toLowerCase()));
                });

            },
            'value' : function(_value)
            {
                if(typeof _value === "undefined" || _value === null || _value.trim().length <= 0)
                {
                    this.initTitle();
                }
            },
            'selected_value': function(_value)
            {
                console.log("Value changed to : "+ _value);
                this.$emit("input", _value);
                if(typeof _value === "undefined" || _value === null || _value.length <= 0)
                    this.arrVisibleOptions = this.options;
            },
            'selected_option': function(_value)
            {
                if(typeof _value === "undefined" || _value === null || _value.length <= 0)
                {
                    this.initTitle();
                }
                else
                {
                    this.selected_title = _value.name;
                    this.selected_value = _value.key;
                }
            },
            'options' : function()
            {
                this.init();
            }
        },
        destroyed() {
            this.$el.removeEventListener("change", this.changeHandler);
        }
    }
</script>